import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CompletionMeterComponent } from './completion-meter/completion-meter.component';

@NgModule({
  declarations: [CompletionMeterComponent],
  imports: [CommonModule, MatIconModule],
  exports: [CompletionMeterComponent]
})
export class CompletionMeterModule { }
